/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCities200,
  GetApiV1LocationCities401,
  GetApiV1LocationCities500,
  GetApiV1LocationCitiesQueryResponse,
} from "../../types/locationCityController/GetApiV1LocationCities.ts";
import { cityViewModelSchema } from "../cityViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCities200Schema = z.array(
  z.lazy(() => cityViewModelSchema),
) as unknown as ToZod<GetApiV1LocationCities200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCities401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCities401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCities500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCities500>;

export const getApiV1LocationCitiesQueryResponseSchema = z.lazy(
  () => getApiV1LocationCities200Schema,
) as unknown as ToZod<GetApiV1LocationCitiesQueryResponse>;
